import React, { useState } from 'react'
import { Input, Button, Modal, message } from 'antd'
import { ProductImportModalProps } from '../types'
import { parseImportText } from '../utils'
import { LARGE_IMPORT_THRESHOLD } from '../constants'

const ProductImportModal: React.FC<ProductImportModalProps> = ({ 
  visible, 
  onCancel, 
  onImport,
  loading
}) => {
  const [importText, setImportText] = useState('')

  const handleImport = () => {
    if (!importText.trim()) {
      message.error('Please enter product IDs')
      return
    }

    const productIds = parseImportText(importText)
    
    if (productIds.length === 0) {
      message.error('No valid product IDs found')
      return
    }

    if (productIds.length > LARGE_IMPORT_THRESHOLD) {
      message.warning('Processing a large number of products may take a while')
    }

    onImport(productIds)
    setImportText('')
  }

  return (
    <Modal
      title={
        <div style={{ 
          fontSize: '16px', 
          fontWeight: 500, 
          color: '#262626', 
          borderBottom: '1px solid #f0f0f0',
          padding: '0 0 16px 0'
        }}>
          Import Product IDs
        </div>
      }
      visible={visible}
      onCancel={() => !loading && onCancel()}
      footer={[
        <Button 
          key="cancel" 
          onClick={onCancel} 
          disabled={loading}
          style={{ borderRadius: '2px' }}
        >
          Cancel
        </Button>,
        <Button
          key="import"
          type="primary"
          loading={loading}
          onClick={handleImport}
          style={{ borderRadius: '2px' }}
        >
          Import
        </Button>,
      ]}
      maskClosable={!loading}
      closable={!loading}
      width={520}
      bodyStyle={{ padding: '20px 24px' }}
    >
      <div style={{ marginBottom: '16px' }}>
        <div style={{ fontSize: '14px', color: '#262626', marginBottom: '8px' }}>
          Paste product IDs (one per line or separated by comma/space):
        </div>
        <div style={{ fontSize: '13px', color: '#8c8c8c', marginBottom: '12px' }}>
          Example: 10840, 10487, 8936190860716, etc.
        </div>
      </div>
      <Input.TextArea
        value={importText}
        onChange={(e) => setImportText(e.target.value)}
        placeholder="10840&#10;10487&#10;8936190860716"
        autoSize={{ minRows: 8, maxRows: 12 }}
        disabled={loading}
        style={{ 
          padding: '12px', 
          fontSize: '14px',
          borderRadius: '2px',
          resize: 'none'
        }}
      />
      {loading && (
        <div style={{ marginTop: '20px', textAlign: 'center' }}>
          <div style={{ marginBottom: '12px', fontSize: '14px', color: '#595959' }}>
            Processing product IDs...
          </div>
          <div
            style={{
              width: '100%',
              height: '4px',
              backgroundColor: '#f5f5f5',
              borderRadius: '4px',
              overflow: 'hidden',
            }}
          >
            <div
              style={{
                width: '30%',
                height: '100%',
                backgroundColor: '#1890ff',
                borderRadius: '4px',
                animation: 'progressAnimation 1.5s infinite',
              }}
            />
          </div>
        </div>
      )}
    </Modal>
  )
}

export default ProductImportModal 